<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <input type="number" class="form-control" :id="safeId()" v-model.lazy.number="localValue">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'number-input-group',
    props: {'label': {}, 'value': {type: Number}},
    data () {
      return {
        localValue: this.value
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/number-input-group.vue